import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import {useFormik} from 'formik';
import {useAuth} from '../../context/AuthContext';
import server from '../../global/server';
import useHandleErrors from '../../hooks/useHandleErrors';
import Typography from '@mui/material/Typography';
import LoadingButton from '@mui/lab/LoadingButton';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import {useNavigate, useSearchParams} from 'react-router-dom';
import logo from '../../assets/logo.png';
import {Box} from '@mui/material';
import {useCookies} from 'react-cookie';
import {sleep} from '../../global/helpers';

const Login = props => {
    const [search] = useSearchParams();
    const {Login} = useAuth();
    const [cookies, setCookies] = useCookies(['user', 'token']);
    const navigation = useNavigate();
    const [hasError, setError] = useState();
    useHandleErrors(hasError);

    const {values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting} =
        useFormik({
            initialValues: {username: '', password: ''},
            onSubmit: async (values, {setSubmitting}) => {
                try {
                    setSubmitting(true);
                    const {data} = await server.post('public/auth', values);
                    Login(data.data.user, data.data.token, '/laudos');
                    navigation('/laudos');
                    setSubmitting(false);
                } catch (error) {
                    setSubmitting(false);
                    setError(error);
                }
            },
        });

    // useEffect(() => {
    //     if (logged) {
    //         navigation('/laudos');
    //     }
    // }, [logged]);

    return (
        <PanelAuth>
            <div>
                <BoxAuth>
                    <form onSubmit={handleSubmit}>
                        <Grid container direction="column" gap={2}>
                            <Grid item xs={12} sx={{textAlign: 'center'}}>
                                <Box
                                    sx={{width: 150, marginBottom: 2}}
                                    component="img"
                                    src={logo}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    variant="outlined"
                                    fullWidth
                                    required
                                    label="Login"
                                    type="text"
                                    name="username"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.username}
                                    //disabled={isOffline}
                                    error={errors.username}
                                    helperText={errors.username}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    variant="outlined"
                                    fullWidth
                                    label="Senha"
                                    type="password"
                                    name="password"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.password}
                                    error={errors.password}
                                    helperText={errors.password}
                                    //disabled={isOffline}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <LoadingButton
                                    type="submit"
                                    fullWidth
                                    loading={isSubmitting}
                                    variant="contained"
                                    disabled={
                                        !(values.username && values.password) || isSubmitting
                                    }>
                                    Entrar
                                </LoadingButton>
                            </Grid>
                            <Grid item xs={12}>
                                <LoadingButton onClick={() => navigation('/recuperar-senha')} fullWidth variant="text" disabled={isSubmitting}>
                                    Recuperar senha
                                </LoadingButton>
                            </Grid>
                        </Grid>
                    </form>
                </BoxAuth>
            </div>
        </PanelAuth>
    );
};

export default Login;

const PanelAuth = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex: 1;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #eee;
`;

const BoxAuth = styled(Grid)`
    border: 1px solid #ccc;
    border-radius: 0.6rem;
    padding: 2rem;
    width: 350px;
    background: white;
`;

const Title = styled.div`
    text-align: center;
    margin-bottom: 20px;
`;
